import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { VaultChipRow } from "../components/VaultChipRow";
import { SwipeRow } from "../components/SwipeRow";
import { TabBar } from "../components/TabBar";
import { useVault } from "../contexts/VaultContext";
import type { RecentEntry } from "../lib/api-types";

export default function Recents() {
  const { selected, toggle } = useVault();
  const navigate = useNavigate();
  const [items, setItems] = useState<RecentEntry[]>([]);

  useEffect(() => {
    const vs = selected.join(",");
    fetch(`/api/recents?vaults=${vs}`)
      .then(r => r.ok ? r.json() : Promise.resolve([]))
      .then(setItems);
  }, [selected]);

  const remove = async (id: string) => {
    await fetch(`/api/recents/${id}`, { method: "DELETE" });
    setItems(prev => prev.filter(x => x.id !== id));
  };

  return (
    <div className="min-h-screen pb-20 px-4 pt-3">
      <h1 className="text-attic-accent font-bold text-base mb-3">attic</h1>
      <h2 className="text-lg font-bold mb-2">Recents</h2>
      <VaultChipRow selected={selected} onToggle={toggle} />
      {items.length === 0 && (
        <p className="text-attic-dim text-xs text-center mt-8">No questions in the last 7 days.</p>
      )}
      {items.map(r => (
        <SwipeRow
          key={r.id}
          actions={[
            { label: "Delete", icon: "🗑", color: "bg-red-600", onClick: () => remove(r.id) },
          ]}
        >
          <button
            onClick={() => {
              const id = crypto.randomUUID();
              sessionStorage.setItem(`pending:${id}`, JSON.stringify({ question: r.question, vaults: r.vaults }));
              navigate(`/answer/${id}`);
            }}
            className="w-full text-left p-3"
          >
            <p className="text-attic-accent font-semibold text-sm">{r.question}</p>
            <p className="text-xs text-attic-dim leading-relaxed mt-1">{r.answerSnippet}</p>
            <div className="flex items-center mt-2 text-[10px] text-attic-dim">
              {r.vaults.map(v => (
                <span key={v} className="bg-attic-accent-bg text-attic-accent px-1.5 py-0.5 rounded font-bold mr-1">{v}</span>
              ))}
              <span className="ml-auto">
                <b className="text-attic-accent">{r.sourceCount}</b> sources
              </span>
            </div>
          </button>
        </SwipeRow>
      ))}
      <TabBar />
    </div>
  );
}
